import type { SVGProps } from "react";
export const DownloadIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    className="fill-current"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.354 15.646a.5.5 0 0 1-.708 0l-4.299-4.299a.5.5 0 0 1-.006-.7l.706-.73a.5.5 0 0 1 .713-.007l1.386 1.386a.5.5 0 0 0 .854-.353V4.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v6.443a.5.5 0 0 0 .854.353L15.24 9.91a.5.5 0 0 1 .713.006l.706.73a.5.5 0 0 1-.006.701zM6 20q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 18v-2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V18q0 .825-.587 1.413A1.92 1.92 0 0 1 18 20z"
    />
  </svg>
);
